import { useEffect, useState } from 'react';
import { playSound, Sound } from '~/assets/sounds';
import { rage } from '~/rage';
import { IVehicleShopVehicle } from '~/shared';

import { VehicleCardOnlyCase } from '../VehicleCardOnlyCase';
import { VehicleCardPreview } from '../VehicleCardPreview';
import { VehicleCardPrice } from '../VehicleCardPrice';
import { VehicleCardStorage } from '../VehicleCardStorage';
import { VehicleTag } from '../VehicleTag';
import {
	StyledCard,
	StyledTagContainer,
	StyledVehicleCardHeader,
	StyledVehicleName,
	StyledVehicleSpecs,
} from './VehicleCard.styled';

interface IVehicleCardProps extends React.HTMLAttributes<HTMLDivElement> {
	data: IVehicleShopVehicle;
	selected: boolean;
}

const VehicleCard = ({ selected, data, ...props }: IVehicleCardProps) => {
	const [isUnseen, setIsUnseen] = useState(
		rage.vehicleShop.isUnseen(`vehicle-${data.model}`),
	);

	useEffect(() => {
		if (selected) {
			rage.vehicleShop.markSeen(`vehicle-${data.model}`);
			setIsUnseen(false);
		}
	}, [selected, data.model]);

	return (
		<StyledCard
			className={selected ? 'selected' : ''}
			{...props}
			onMouseEnter={() => playSound(Sound.LinkCursor)}
		>
			<StyledVehicleCardHeader>
				<StyledVehicleName>{data.name}</StyledVehicleName>
				<StyledTagContainer>
					{isUnseen && <VehicleTag type="new" />}
					{data.tags?.discount && (
						<VehicleTag type="discount" discount={data.tags.discount} />
					)}
					{data?.tags?.onlyCase && <VehicleTag type="onlyCase" />}
				</StyledTagContainer>
			</StyledVehicleCardHeader>
			<VehicleCardPreview model={data.model} />
			<StyledVehicleSpecs>
				<VehicleCardStorage amount={data.specs.trunkVolume} />
				{data?.tags?.onlyCase ? (
					<VehicleCardOnlyCase name={data?.caseName} />
				) : (
					<VehicleCardPrice amount={data.priceCash} />
				)}
			</StyledVehicleSpecs>
		</StyledCard>
	);
};

// -webkit-mask-image: linear-gradient(
// 	to right,
// 	transparent,
// 	#000 60px,
// 	#000 calc(100% - 60px),
// 	transparent
// );

export { VehicleCard };
